<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`出车费用汇总`)">导出</el-button>
        </el-form-item>

        <!-- 过磅单导出 -->
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';

export default {
  components: { Wxts },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'carall',
      breadcrumb: [
        { name: "财务管理" },
        { name: "出车费用汇总表" },
      ],
      wxtsList: [
        {
          name: '如需增减字段，可在【系统设置】',
          path: '/system/drivingFee',
          pathName: '【出车费用配置】',
          tailName: '处设置。',
        },
      ],
      formCtrl: [
        {
          ...this.ctrls.month
        },
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license
        },
      ],
      cols: [
        { keyName: "vtype", label: "车辆类型", minwidth: '110px' },
        { keyName: "license", label: "车牌号", minwidth: '110px' },
        { keyName: "driver", label: "司机姓名", minwidth: '110px' },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          title: '费用明细',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ license }) => {
            const o = {}
            const { month } = this.formInline
            if (month) {
              o['predict_unloading_date'] = this.getMonthRange(month)
            }
            const path = '/finance/tabledetails'
            this.setStore({
              ['formInline' + path]: o,
            })
            this.$nextTick(() => {
              this.$router.push({
                path,
                query: {
                  license,
                }
              });
            })
          },
        },
      ],
      baseParams: ['month'],
      formInline: {
        fleet: '',
        month: '',
      },
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `carall/expicture`;
      const params = {
        // userid: this.user.id,
        month: this.formInline.month,
      }

      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          // link.download = "过磅单"
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },

    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          const ele = v[key]
          if (key == 'sum_fields' && (typeof ele === 'object')) {
            for (const key1 in ele) {
              if (Object.prototype.hasOwnProperty.call(ele, key1)) {
                o[key1] = ele[key1];
              }
            }
          } else {
            o[key] = v[key];
          }
        }
      }
      return o
    },
    setOptions({ team, month, dayauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet') {
          // console.log('team', team)
          this.setCtrlOption(v, team, 'nickname')
          // console.log({ ...v })
        }
      })
      // console.log(this.formCtrl)
      this.MONTH = this.formInline.month = month
      const arr = []
      const arr1 = []
      dayauth.map(v => {
        const o = {
          keyName: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          sortable: true,
        }
        if (v.authname.length > 3) {
          o.width = 100
        }
        if (['里程工资',].includes(v.authname)) {
          arr1.push(o)
        } else {
          arr.push(o)
        }
      })
      this.cols.push(...arr)
      this.cols.push(...arr1)
      this.cols.push(
        { keyName: "doil", label: "现金加油", align: 'right', className: 'pr30', minwidth: '110px', sortable: true },
        { keyName: "dtotal", label: "费用合计", align: 'right', className: 'pr30', minwidth: '110px', sortable: true },
      )
      this.doLayout()
      this.getTotalProperty = [
        ...arr1.map(v => v.keyName), ...arr.map(v => v.keyName), 'doil', 'moneydoil', 'total', 'dtotal',
      ]
      this.$forceUpdate()
      // console.log({ ...this.formInline })
      if (Object.keys(this.$route.query).length) {
        this.setQueryParams()
        this.$nextTick(this.getList)
      } else {
        this.getList()
      }
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
      // 本身有baseParams不需要手动触发getList
    }
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>